import React from 'react';

import { SignupConsumerByPeoPageForm } from 'src/components/auth';
import { PositionDetailsModal } from 'src/modals/position';
import { AuthSignupConsumerPeoProvider } from 'src/providers/AuthSignupConsumerProvider';

export const SignupConsumerByPeoPage: React.FC = () => {
  return (
    <AuthSignupConsumerPeoProvider>
      <SignupConsumerByPeoPageForm />

      <PositionDetailsModal />
    </AuthSignupConsumerPeoProvider>
  );
};
